<template>
  <div
    ref="cont"
    class="selectspace"
    @mouseleave="reset"
    @mouseup="handleMouseup"
    @mousedown="handleMousedown"
    @mousemove="handleMousemove"
  >
    <div
      class="selectspace_selection"
      :style="zoomStyle"
    >
      <!-- {{ selectionPercentace }} -->
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'

export default {
  name: 'SelectSpaceOverlay',
  props: {
    oopPlayer: Object,
    ipPlayer: Object,
    disabled: Boolean,
  }, 
 emits: ['update:selection'],
  data() {
    return {
      mousedown: false,
      zoomStyle: '',
      cursorX: 0,
      startX: 0,
      selectionPercentace: 0,
      selectionEndPercentage: 0,
    }
  },
  methods: {
    handleMousedown(e) {
      if (this.disabled) return
      this.mousedown = true
      this.startX = this.getCursorX(e)
    },
    handleMouseup() {
      if (this.disabled) return
      if (!this.selectionPercentace) {
        this.reset()
        return
      }
      this.$emit('update:selection', {
        percent: this.selectionPercentace,
        end: this.selectionEndPercentage,
      })
      this.reset()
    },
    reset() {
      this.mousedown = false
      this.startX = 0
      this.zoomStyle = ''
      this.cursorX = 0
      this.selectionPercentace = 0
      this.selectionEndPercentage = 0
    },
    handleMousemove: throttle(function (e) {
      if (!this.mousedown) return
      this.cursorX = this.getCursorX(e)
      this.getZoomBoxPlacement()
    }, 20),
    getCursorX(e) {
      if (e?.touches) {
        e = {
          pageX: e?.touches[0]?.pageX,
        }
      }
      const bbr = this.$refs.cont.getBoundingClientRect()
      let cursorX = e?.pageX - bbr.x
      cursorX = cursorX < 0 ? 0 : cursorX > bbr.width ? bbr.width : cursorX
      return cursorX
    },
    getZoomBoxPlacement() {
      let start = this.startX
      let width = this.cursorX - start
      const flipped = start > this.cursorX
      if (flipped) {
        start -= start - this.cursorX
        width = Math.abs(width)
      }
      if (!width) return

      const res = `left:${start}px; width:${width}px;`
      //   console.log(res, this.startX, this.cursorX)
      const end = flipped ? this.cursorX : start
      const bbr = this.$refs.cont.getBoundingClientRect()
      this.selectionPercentace = width / bbr.width
      this.selectionEndPercentage = end / bbr.width
      // console.log(end, bbr.width)
      this.zoomStyle = res
    },
  },
}
</script>
<style lang="scss" scoped>
.selectspace {
  position: absolute;
  // background: rgba(255, 0, 0, 0.273);
  width: 100%;
  height: 100%;
  cursor: crosshair;

  &_selection {
    background: rgba(255, 255, 255, 0.1);
    height: 100%;
    position: absolute;
    z-index: 4;
  }
}
</style>
